import { render, staticRenderFns } from "./PopupFoodDairySubmitting.vue?vue&type=template&id=48202e54"
import script from "./PopupFoodDairySubmitting.vue?vue&type=script&lang=js"
export * from "./PopupFoodDairySubmitting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports